module.exports = __webpack_public_path__ + "media/images/glyphs/placeholder-fdcd141fd1e84472fca43ca477251377.svg";